import { Icon } from 'vetrf-ui';
import styles from 'components/Timeline/Timeline.module.scss';
import { useUserDataContext } from 'components/UserDataContext/context';
import { useGetPermission } from 'utils/hooks/useGetPermission';
import { ROLES } from 'utils/consts/roles';
import { RequestTracingItemDTO } from 'api/requestMotion/types';

type RequestMotionItemProps = {
  item: RequestTracingItemDTO;
};

export const RequestMotionItem = ({
  item: {
    additionalInformationDate,
    changeDossierDate,
    considerationPeriodType,
    decisionDate,
    deregistrationDate,
    documentDate,
    documentNumber,
    documentType,
    endValidityDate,
    fileList,
    renewRegistrationDate,
    startValidityDate,
    suspensionPeriodDate,
    vgnkiDecisionDate,
    vgnkiRequestDate,
  },
}: RequestMotionItemProps) => {
  const { userData } = useUserDataContext();
  const VGNKIPermission = useGetPermission(ROLES.requestMotionEdit, userData);

  return (
    <div>
      {considerationPeriodType && (
        <div>Количество дней рассмотрения: {considerationPeriodType.name}</div>
      )}

      {vgnkiDecisionDate && VGNKIPermission && (
        <div>Дата заключения ВГНКИ: {vgnkiDecisionDate}</div>
      )}

      {vgnkiRequestDate && <div>Дата запроса ВГНКИ: {vgnkiRequestDate}</div>}

      {renewRegistrationDate && <div>Дата возобновления: {renewRegistrationDate}</div>}

      {startValidityDate && (
        <>
          <div>Дата регистрации: {startValidityDate}</div>
          <div>Срок государственной регистрации: {endValidityDate || 'бессрочно'}</div>
        </>
      )}

      {suspensionPeriodDate && <div>Срок приостановления: {suspensionPeriodDate}</div>}

      {decisionDate && <div>Дата принятия решения: {decisionDate}</div>}

      {changeDossierDate && <div>Дата внесения изменений в досье: {changeDossierDate}</div>}

      {deregistrationDate && <div>Дата отмены регистрации: {deregistrationDate}</div>}

      {additionalInformationDate && <div>Дата ответа на запрос: {additionalInformationDate}</div>}

      {documentType?.name && (
        <div>
          <Icon color="blue" icon="file" size={150} />
          {fileList?.length ? (
            <a href={`/files/${fileList[0].id}`} className={styles.documentName}>
              {documentType.name}
            </a>
          ) : (
            <span className={styles.documentName}>{documentType.name}</span>
          )}
          {documentNumber && <span> №{documentNumber} </span>}
          {documentDate && <span> от {documentDate}</span>}
        </div>
      )}
    </div>
  );
};
